
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.145 9.453a.86.86 0 00-.86-.86h-8.85a.86.86 0 100 1.72h8.85a.86.86 0 00.86-.86zM5.434 12.031a.86.86 0 000 1.719h5.376a.86.86 0 100-1.719H5.434z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.453 20.281H4.58a1.72 1.72 0 01-1.719-1.718V3.438a1.72 1.72 0 011.72-1.72h10.565a1.72 1.72 0 011.718 1.72v5.285a.86.86 0 101.72 0V3.437A3.441 3.441 0 0015.144 0H4.579a3.441 3.441 0 00-3.437 3.438v15.124A3.441 3.441 0 004.579 22h2.874a.86.86 0 100-1.719z","fill":"#fff"}}),_c('path',{attrs:{"d":"M20.105 12.443a2.58 2.58 0 00-3.646-.001l-4.718 4.707c-.1.1-.174.224-.215.359L10.5 20.891a.86.86 0 001.051 1.078l3.469-.961a.86.86 0 00.378-.22l4.708-4.7a2.581 2.581 0 000-3.646zm-5.763 6.969l-1.745.483.511-1.681 3.183-3.176 1.216 1.215-3.165 3.159zm4.548-4.54l-.166.167-1.216-1.216.166-.165a.86.86 0 011.216 1.215zM14.286 5.156H5.434a.86.86 0 100 1.719h8.852a.86.86 0 100-1.719z","fill":"#fff"}})])
          )
        }
      }
    